import { atom } from 'jotai/index';
import { archivedSafesAtom, pendingSafesAtom, safesAtom } from 'store';
import { IClaimMultiSignWallet } from 'types';

// export const fetchPendingSafesAtom = atom<null, [string], void>(null, (get, set, network) => {
//   const net: StxChain =
//     network === 'testnet' ? StxChain.STX_TESTNET_CHAIN : StxChain.STX_MAINNET_CHAIN;

//   getPendingMultisigs(net).then((pendingMulitisgsResponse) => {
//     const newData = pendingMulitisgsResponse.data.filter((item) => item.status === 'QUEUED');
//     if (!isEqual(get(pendingSafesAtom), newData)) {
//       set(pendingSafesAtom, newData);
//     }
//   });
// });

// export const fetchSafesAtom = atom<null, [string], void>(null, (get, set, network) => {
//   const net: StxChain =
//     network === 'testnet' ? StxChain.STX_TESTNET_CHAIN : StxChain.STX_MAINNET_CHAIN;

//   getAllMyMultisigs(net).then((multisigsResponse) => {
//     if (!isEqual(get(safesAtom), multisigsResponse)) {
//       set(safesAtom, multisigsResponse);
//     }
//   });
// });

export const updatedArchievedSafeAtom = atom<null, [IClaimMultiSignWallet, boolean], void>(
  null,
  (get, set, updatedSafe, isArchieve) => {
    if (isArchieve) {
      set(
        safesAtom,
        get(safesAtom).filter((x) => x._id !== updatedSafe._id)
      );
      set(archivedSafesAtom, [...get(archivedSafesAtom), updatedSafe]);
    } else {
      set(
        archivedSafesAtom,
        get(archivedSafesAtom).filter((x) => x._id !== updatedSafe._id)
      );
      set(safesAtom, [...get(safesAtom), updatedSafe]);
    }
  }
);

export const clearSafesAtom = atom(null, (get, set) => {
  set(pendingSafesAtom, []);
  set(safesAtom, []);
  set(archivedSafesAtom, []);
});
